// Helper functions for generating Capital Impact chart data

import { getFilteredReportData } from '../helpers/filterHelpers'
import { CAPITAL_IMPACT } from '../fields'

const capitalTypeLabels = {
  scx: 'Social Capital',
  hcx: 'Human Capital',
  ncx: 'Natural Capital'
}

// Generate chart data for capital impact
const generateCapitalImpactChartData = capitalImpactData => {
  if (capitalImpactData) {
    const labels = Object.values(capitalTypeLabels)
    const data = [capitalImpactData.scx || 0, capitalImpactData.hcx || 0, capitalImpactData.ncx || 0]

    return {
      labels: labels,
      datasets: [
        {
          label: 'Capital Impact',
          data: data,
          backgroundColor: ['#D08B67', '#E2C6AA', '#D6AD68'],
          spacing: 1,
          borderRadius: 8
        }
      ]
    }
  } else {
    return {
      labels: [],
      datasets: []
    }
  }
}

// Main function to generate chart data
export const generateCapitalImpactData = ({ selectedRegion, selectedStakeholder, report }) => {
  const capitalImpactData = getFilteredReportData({
    report,
    selectedRegion,
    selectedStakeholder,
    fieldName: CAPITAL_IMPACT
  })
  return generateCapitalImpactChartData(capitalImpactData)
}
